export function formatDate(date: string): string {
    const dates = date.split("-");
    if (dates.length != 3) {
        return date;
    }
    return `${dates[2]}/${dates[1]}/${dates[0]}`;
}